/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisqualifiedTeamInfo
 */
export interface DisqualifiedTeamInfo {
    /**
     * 
     * @type {string}
     * @memberof DisqualifiedTeamInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DisqualifiedTeamInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DisqualifiedTeamInfo
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof DisqualifiedTeamInfo
     */
    disqualifiedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof DisqualifiedTeamInfo
     */
    disqualificationReason?: string;
}

/**
 * Check if a given object implements the DisqualifiedTeamInfo interface.
 */
export function instanceOfDisqualifiedTeamInfo(value: object): value is DisqualifiedTeamInfo {
    return true;
}

export function DisqualifiedTeamInfoFromJSON(json: any): DisqualifiedTeamInfo {
    return DisqualifiedTeamInfoFromJSONTyped(json, false);
}

export function DisqualifiedTeamInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisqualifiedTeamInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'disqualifiedAt': json['disqualifiedAt'] == null ? undefined : json['disqualifiedAt'],
        'disqualificationReason': json['disqualificationReason'] == null ? undefined : json['disqualificationReason'],
    };
}

export function DisqualifiedTeamInfoToJSON(json: any): DisqualifiedTeamInfo {
    return DisqualifiedTeamInfoToJSONTyped(json, false);
}

export function DisqualifiedTeamInfoToJSONTyped(value?: DisqualifiedTeamInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'status': value['status'],
        'disqualifiedAt': value['disqualifiedAt'],
        'disqualificationReason': value['disqualificationReason'],
    };
}

